import { Layout, Menu, theme } from 'antd'
import { HomeOutlined, GithubOutlined } from '@ant-design/icons'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'

const { Header, Content, Footer } = Layout

export function AppLayout() {
  const {
    token: { colorBgContainer },
  } = theme.useToken()
  const navigate = useNavigate()
  const location = useLocation()

  const selectedKey = location.pathname.startsWith('/projects') || location.pathname.startsWith('/jobs')
    ? '/projects'
    : location.pathname

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Header style={{ display: 'flex', alignItems: 'center', padding: '0 24px' }}>
        <div
          style={{ color: 'white', fontSize: 18, fontWeight: 600, marginRight: 40, cursor: 'pointer' }}
          onClick={() => navigate('/projects')}
        >
          AI 装修工程量平台
        </div>
        <Menu
          theme="dark"
          mode="horizontal"
          selectedKeys={[selectedKey]}
          onClick={({ key }) => navigate(key)}
          style={{ flex: 1, minWidth: 0 }}
          items={[
            { key: '/projects', icon: <HomeOutlined />, label: '项目' },
          ]}
        />
        <a
          href={`${window.location.protocol}//${window.location.hostname}:8765/docs`}
          target="_blank"
          rel="noreferrer"
          style={{ color: '#aaa', marginLeft: 16 }}
        >
          <GithubOutlined /> API 文档
        </a>
      </Header>
      <Content style={{ padding: '24px 48px' }}>
        <div
          style={{
            padding: 24,
            minHeight: 'calc(100vh - 180px)',
            background: colorBgContainer,
            borderRadius: 8,
          }}
        >
          <Outlet />
        </div>
      </Content>
      <Footer style={{ textAlign: 'center', color: '#999' }}>
        AI 商业装修 Agent 平台 · V1 · Proprietary
      </Footer>
    </Layout>
  )
}
